import { render, staticRenderFns } from "./PageBayuerdeskV2.vue?vue&type=template&id=42ba7292&scoped=true&"
import script from "./PageBayuerdeskV2.vue?vue&type=script&lang=js&"
export * from "./PageBayuerdeskV2.vue?vue&type=script&lang=js&"
import style0 from "./PageBayuerdeskV2.vue?vue&type=style&index=0&id=42ba7292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba7292",
  null
  
)

export default component.exports